import React from "react";
import styles from "./Navbar.module.scss";

const PrivilegeBlock = ({ children, show }) => {
  if (!show) return null;

  return <div className={styles.blueBorder}>{children}</div>;
};

export default PrivilegeBlock;
